import { render, staticRenderFns } from "./r-item-recycle-mode.vue?vue&type=template&id=ceaefcc2"
import script from "./r-item-recycle-mode.vue?vue&type=script&lang=js"
export * from "./r-item-recycle-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ceaefcc2')) {
      api.createRecord('ceaefcc2', component.options)
    } else {
      api.reload('ceaefcc2', component.options)
    }
    module.hot.accept("./r-item-recycle-mode.vue?vue&type=template&id=ceaefcc2", function () {
      api.rerender('ceaefcc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/recycle/r-item-recycle-mode.vue"
export default component.exports